import { render } from "./cdrBatchConsumptionDetails.vue?vue&type=template&id=5d9fe882&scoped=true"
import script from "./cdrBatchConsumptionDetails.vue?vue&type=script&lang=js"
export * from "./cdrBatchConsumptionDetails.vue?vue&type=script&lang=js"

import "./cdrBatchConsumptionDetails.vue?vue&type=style&index=0&id=5d9fe882&scoped=true&lang=css"
import "./cdrBatchConsumptionDetails.vue?vue&type=style&index=1&id=5d9fe882&lang=css"
script.render = render
script.__scopeId = "data-v-5d9fe882"

export default script